import { useRef } from "react";
import useImagesLoaded from "../../hooks/useImagesLoaded";

import Welcome from "../../components/Welcome/Welcome";
import WelcomeBridge from "../../components/Welcome/WelcomeBridge";
import ProductShowcase from "../../components/ProductShowcase/ProductShowcase";
import UseCases from "../../components/UseCases/UseCases";
import EcosystemSection from "../../components/EcosystemSection/EcosystemSection";
import Capabilities from "../../components/Capabilities/Capabilities";
import Contact from "../../components/Contact/Contact";

export default function Home() {
  const containerRef = useRef(null);
  useImagesLoaded(containerRef); // ← waits for all images before GSAP runs

  return (
    <main className="home" ref={containerRef}>
      {/* HERO */}
      <Welcome />
      <WelcomeBridge />
      <ProductShowcase />
      <UseCases />
      <EcosystemSection />
      <Capabilities />
      <Contact />
    </main>
  );
}